import React, { useEffect, useState } from 'react';
import { Box, Popover } from '@mui/material';
import BottomSheetOrDialog from '../../../components/BottomSheetOrDialog/BottomSheetOrDialog';

export default function RemarkEditorOverlay({ open, anchorEl, onClose, mobile, title, actions, children }) {
  const [viewport, setViewport] = useState(null);

  useEffect(() => {
    // Forget the last measurement on close: the keyboard usually dismisses after
    // the listeners are gone, so a kept value would reopen the sheet at the
    // keyboard-shrunk height for a frame.
    if (!open || !mobile) {
      setViewport(null);
      return undefined;
    }
    const visualViewport = window.visualViewport;
    const update = () => {
      const height = visualViewport ? visualViewport.height : window.innerHeight;
      const offsetTop = visualViewport ? visualViewport.offsetTop : 0;
      setViewport({ height, bottom: Math.max(0, window.innerHeight - height - offsetTop) });
    };
    update();
    window.addEventListener('resize', update);
    visualViewport?.addEventListener('resize', update);
    visualViewport?.addEventListener('scroll', update);
    return () => {
      window.removeEventListener('resize', update);
      visualViewport?.removeEventListener('resize', update);
      visualViewport?.removeEventListener('scroll', update);
    };
  }, [open, mobile]);

  if (mobile) {
    return (
      <BottomSheetOrDialog
        className="create-demo-remark-sheet"
        open={open}
        onClose={onClose}
        header={title}
        content={children}
        actions={[actions]}
        BottomSheetProps={{
          initialFocusRef: false,
          expandOnContentDrag: false,
          maxHeight: viewport ? Math.max(1, viewport.height - 16) : undefined,
          style: { '--remark-sheet-bottom': `${viewport?.bottom || 0}px` }
        }}
      />
    );
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <div style={{ padding: '16px', width: '280px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {children}
        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>{actions}</Box>
      </div>
    </Popover>
  );
}
